import { AsyncStatus, defaultInitialState, State } from 'hooks/useAsync';
import ZohoService, { ZohoVerifyIntegrationResult } from './ZohoService';
import { useCallback, useState } from 'react';

const useVerifyZohoIntegration = () => {
  const [{ error, isLoading, data, status }, setState] =
    useState<State<ZohoVerifyIntegrationResult>>(defaultInitialState);

  const verifyZohoIntegration = useCallback(async () => {
    setState({
      error: null,
      status: AsyncStatus.pending,
      data: null,
      isLoading: true,
    });
    const resultPromise = ZohoService.verifyZohoIntegration();
    resultPromise.then(
      (result) => {
        setState({
          error: null,
          status: AsyncStatus.resolved,
          data: result,
          isLoading: false,
        });
      },
      (error) => {
        setState({
          error: error,
          status: AsyncStatus.rejected,
          data: null,
          isLoading: false,
        });
      },
    );
  }, [setState]);

  return {
    verifyZohoIntegration,
    error,
    isLoading,
    isError:
      status === AsyncStatus.rejected ||
      (data?.data ? !data?.data.isSuccess : false),
    isSuccess: status === AsyncStatus.resolved && data?.data.isSuccess,
    data,
  };
};

export default useVerifyZohoIntegration;
